/** @prettier */
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import RedirectForLoggedOut from '@xanadu/ui-shared/components/RedirectForLoggedOut';
import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncPortfolio = async(() =>
  import('@xanadu/ui-shared/components/portfolio/Portfolio').then((module) => module.default)
);

const AsyncPositions = async(() =>
  import('@xanadu/ui-shared/components/portfolio/Positions').then((module) => module.default)
);

const AsyncOpenOrders = async(() =>
  import('@xanadu/ui-shared/components/portfolio/OpenOrders').then((module) => module.default)
);

const AsyncSettledTrades = async(() =>
  import('@xanadu/ui-shared/components/portfolio/SettledTrades').then((module) => module.default)
);

const AsyncHistory = async(() =>
  import('@xanadu/ui-shared/components/portfolio/History').then((module) => module.default)
);

const Portfolio = ({ tabs }) => (
  <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
    <RedirectForLoggedOut />
    <Route path="/portfolio">
      <Switch>
        <Redirect exact from="/portfolio/" to="/portfolio/positions" />
        <Redirect exact from="/portfolio" to="/portfolio/positions" />
        <AsyncPortfolio tabs={tabs}>
          <Route path="/portfolio/positions" component={AsyncPositions} />
          <Route path="/portfolio/open-orders" component={AsyncOpenOrders} />
          <Route path="/portfolio/settled-trades" component={AsyncSettledTrades} />
          <Route path="/portfolio/history" component={AsyncHistory} />
        </AsyncPortfolio>
      </Switch>
    </Route>
  </div>
);

Portfolio.propTypes = {
  tabs: PropTypes.array.isRequired,
};

export default Portfolio;
